exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/app/authorized/admin-sounds/admin-sounds.component.scss
// module id = ../../../../../src/app/authorized/admin-sounds/admin-sounds.component.scss
// module chunks = main